<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons danger">remove_circle</span>
        <span class="soc-panel-h">{{'WRITE_OFF.WRITE_OFF' | translate}}</span>
    </div>
    <hr class="soc-panel-line">
    <div class="soc-wrapper-gap-4">
        <span class="soc-secondary-text">{{writeOff.item?.code}}</span>
        <i class="pi pi-circle-fill soc-numbering-dot"></i>
        <span class="soc-h1">{{writeOff.item?.name}}</span>
    </div>
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-addon-input-group">
            <label for="quantity" class="soc-input-lbl w-100 text-start">{{'WRITE_OFF.QUANTITY' | translate}}</label>
            <div class="soc-error-field-wrapper w-100">
                <span *ngIf="quantity.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <div class="p-inputgroup">
                    <input [(ngModel)]="writeOff.quantity" placeholder="{{'TYPE_HERE' | translate}}" class="soc-input-text w-100" type="text" [ngClass]="{'soc-error-active': quantity.invalid && f.submitted}" id="quantity" required name="quantity" #quantity="ngModel" type="text">   
                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important; " [ngClass]="{'soc-error-active-addon': quantity.invalid && f.submitted}">{{ writeOff.item && writeOff.item.unitType ? (writeOff.item.unitType | unitShortener | lowercase) : '' }}</span>      
                </div>
            </div>
        </div>
        <div class="soc-input-wrapper">
            <label for="invoiceNumber" class="soc-input-lbl w-100 text-start">{{'WRITE_OFF.REASON' | translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="reason.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': reason.invalid && f.submitted}" id="reason" [required]="true" name="reason" #reason="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="writeOff.reason">
            </div>
        </div>
        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button" (click)="close()">{{'CLOSE' | translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit"  (click)="apply(f)">{{'APPLY' | translate}}</button>
        </div>
    </form>
</div>
